'use client';

import { useMemo, useState } from 'react';
import dynamic from 'next/dynamic';
import { UnstyledButton } from '@zillow/constellation-10';
import { FederatedPhoto } from '@/src/components/FederatedPhoto';
import * as styles from './floorPlanImageViewer.styles';

const PhotoLightboxModal = dynamic(() => import('@/src/components/MediaModal').then((mod) => mod.PhotoLightboxModal));

type FloorPlanImageViewerProps = {
  src: string;
  alt: string;
  buttonLabel: string;
  imageClassName?: string;
  loading?: 'eager' | 'lazy';
};

export const FloorPlanImageViewer = ({ src, alt, buttonLabel, imageClassName, loading }: FloorPlanImageViewerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const photos = useMemo(() => [{ url: src, caption: alt }], [alt, src]);

  return (
    <>
      <UnstyledButton type="button" css={styles.trigger} onClick={() => setIsOpen(true)} aria-label={buttonLabel}>
        <FederatedPhoto
          src={src}
          alt={alt}
          defaultSize={768}
          preserveSource
          className={imageClassName}
          loading={loading}
        />
      </UnstyledButton>

      {isOpen ? (
        <PhotoLightboxModal isOpen={isOpen} onClose={() => setIsOpen(false)} photos={photos} ariaLabel={alt} />
      ) : null}
    </>
  );
};
